import { generateUUID } from "three/src/math/MathUtils";

export const generateFileName = (baseName = "audio") => {
  return `${baseName}-${generateUUID()}`;
};
